import appSlice from "../AppSlice";
import infoPageSlice from "../components/InfoPage/InfoPageSlice";
import dashboardSlice from "../components/Dashboard/DashboardSlice";
import imageCaptureSlice from "../components/ImageCapture/ImageCaptureSlice";
import languageSelectSlice from "../components/LanguageSelect/LanguageSelectSlice";
import registrationPageSlice from "../components/RegistrationPage/RegistrationPageSlice";
import { configureStore } from "@reduxjs/toolkit";
import type { Action, ThunkAction } from "@reduxjs/toolkit";
import contactInfoSlce from "../components/CompletionPage/ContactInfoSlice";
import queueSlice from "../components/Queue/QueueSlice";

export const store = configureStore({
  reducer: {
    app: appSlice,
    registrationPage: registrationPageSlice,
    languageSelect: languageSelectSlice,
    infoPage: infoPageSlice,
    imageCapture: imageCaptureSlice,
    dashboard: dashboardSlice,
    contactInfo: contactInfoSlce,
    queue: queueSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
